import {Component, Prop} from 'vue-property-decorator';
import * as tsx from 'vue-tsx-support';
import '@/utils/transform.js';
import Transform from '@/utils/transform.ts';
import AlloyTouch from 'alloytouch';
import Device, {justifyContent} from '@/components/Device';

import './style.less';

interface IMyFocus {
  dataSource?: any;
  events?: any
}

@Component
export default class MyFocus extends tsx.Component<IMyFocus> {
  
  @Prop() dataSource?: any
  @Prop() events?: any
  
  data() {
    return {
      activeIndex: 1
    }
  }
  
  mounted() {
    this.newMyFocus({})
  }
  
  newMyFocus(basicData) {
    const {
      initialSlide = 0, //设定初始化时slide的索引。
      loop = false, //是否循环
      pagination = false,
      paginationEl = '#nav a',
      perViewEl = '.device-container',
      scrollerEl = '#carousel-scroller',
      containerEl = '#carousel-container' // //反馈触摸的dom
    } = basicData
    
    this.initMyFocus({
      initialSlide,
      loop,
      pagination,
      paginationEl,
      perViewEl,
      scrollerEl,
      containerEl
    })
  }
  
  getEl(basicData) {
    return {
      items: document.querySelectorAll(basicData.paginationEl),
      scroller: this.$refs.scroller,
      slides: document.querySelectorAll(basicData.perViewEl)
    }
  }
  
  initMyFocus(basicData) {
    const {dataSource = [],} = this.$props;
    const {scroller} = this.getEl(basicData)
    Transform(scroller);
    let myFocus = new AlloyTouch({
      touch: this.$refs.container,
      vertical: false,//不必需，默认是true代表监听竖直方向touch
      target: scroller, //运动的对象
      property: 'translateX',  //被运动的属性
      min: window.innerWidth * dataSource.length * -1, //不必需,运动属性的最小值
      max: 0, //不必需,滚动属性的最大值
      step: window.innerWidth,
      spring: true, //不必需,是否有回弹效果。默认是true
      inertia: true, //不必需,是否有惯性。默认是true
      touchEnd: (evt, v, index) => this.touchEnd(evt, v, index, myFocus),
      animationEnd: (evt, v) => this.animationEnd(evt, v, myFocus)
    })
    
    myFocus.to((basicData.initialSlide + 1) * myFocus.step * -1 + myFocus.step);
    
  }
  
  animationEnd(evt, v, myFocus) {
    this.$data.activeIndex = myFocus.currentPage;
    this.$props.events.swiperOnChange(myFocus.currentPage)
  }
  
  touchEnd(evt, v, index, myFocus, ) {
    // if (Math.abs(v) > this.$props.dataSource.length * myFocus.step + 1) {
    //   myFocus.to(index * myFocus.step);
    //   return false
    // }
  
    const min =  window.innerWidth * (this.$props.dataSource.length) * -1
    let step_v = index * myFocus.step * -1;
    let dx = v - step_v;
    if(v < min) {
      console.log('触发', v, min)
      myFocus.to(min);
    } else if(v > myFocus.max) {
      myFocus.to(myFocus.max);
    } else if(Math.abs(dx) < 30) { // 左右移动
      myFocus.to(step_v);
    }
    else if(dx > 0) {
      if (index === 0) {
        myFocus.to(0);
      } else {
        myFocus.to(step_v + myFocus.step);
      }
      
    } else {
      if (index >= this.$props.dataSource.length) {
        myFocus.to(this.$data.activeIndex * myFocus.step * -1);
        return false
      }
      myFocus.to(step_v - myFocus.step);
    }
    return false;
  }
  
  getJustifyContent (index: number) {
    const {activeIndex} = this.$data;
    if (activeIndex === index) {
      return justifyContent.center
    }
    if (activeIndex < index) {
      return justifyContent.left
    }
    return justifyContent.right
  }
  
  render() {
    const {events,dataSource = [],} = this.$props;
    return (
      <div>
        <div ref="container" id="carousel-container">
          <div class="carousel">
            <div ref="scroller" style={`width: ${(dataSource.length + 1) * 100}%`} class="carousel-scroller" id="carousel-scroller">
              {dataSource.map((data, index) => {
                return (
                  <div class="slide">
                    <Device justifyContent={this.getJustifyContent(index)} activeType={this.$data.activeIndex === index} events={events} data={data}/>
                  </div>
                )
              })}
              <div class="slide">
                <Device justifyContent={this.getJustifyContent(dataSource.length)} activeType={this.$data.activeIndex !== dataSource.length -1} events={events} type='2'/>
              </div>
            </div>
          </div>
        </div>
      
      </div>
    )
  }
  
}